import { awsGenAiPlugin } from './plugin';
export default awsGenAiPlugin;